import React from 'react'
import './home.css'
import { useRef } from "react";
import { Helmet } from 'react-helmet';


export default function Carservicebrands() {

    const sliderRef = useRef(null);
      let isDown = false;
      let startX;
      let scrollLeft;
    
      const startDrag = (e) => {
        isDown = true;
        sliderRef.current.classList.add("active");
        startX = e.pageX - sliderRef.current.offsetLeft;
        scrollLeft = sliderRef.current.scrollLeft;
      };
    
      const stopDrag = () => {
        isDown = false;
        sliderRef.current.classList.remove("active");
      };
    
      const onDrag = (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - sliderRef.current.offsetLeft;
        const walk = (x - startX) * 2;
        sliderRef.current.scrollLeft = scrollLeft - walk;
      };
    
    
  return (
    <>
<Helmet>
  <script type="application/ld+json">
{`
{
  "@context": "https://schema.org",
  "@type": "ItemList",
  "name": "Car Brands We Service",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "item": {
        "@type": "Brand",
        "name": "Maruti Suzuki"
      }
    },
    {
      "@type": "ListItem",
      "position": 2,
      "item": {
        "@type": "Brand",
        "name": "Hyundai"
      }
    },
    {
      "@type": "ListItem",
      "position": 3,
      "item": {
        "@type": "Brand",
        "name": "Honda"
      }
    }
    ,
    {
      "@type": "ListItem",
      "position": 4,
      "item": {
        "@type": "Brand",
        "name": "Toyota"
      }
    }
    ,
    {
      "@type": "ListItem",
      "position": 5,
      "item": {
        "@type": "Brand",
        "name": "Volkswagen"
      }
    }
    ,
    {
      "@type": "ListItem",
      "position": 6,
      "item": {
        "@type": "Brand",
        "name": "Land Rover"
      }
    }
  ]
}
`}
</script>

  <title>
    Car mechanic for All Major Brands | Audi, BMW, Mercedes & More
  </title>

  <meta
    name="description"
    content="We provide professional car servicing and repairs for all major car brands including Audi, BMW, Mercedes, Toyota, Honda, Hyundai, Volkswagen, and Land Rover."
  />

  <link
    rel="canonical"
    href="https://car-repair-mechanic-palwal.netlify.app/"
  />
</Helmet>

     <section className="brandSection">
      <h2>We Repair All Major Car Brands</h2>

      <div
        className="brandSlider"
        ref={sliderRef}
        onMouseDown={startDrag}
        onMouseLeave={stopDrag}
        onMouseUp={stopDrag}
        onMouseMove={onDrag}
      >
        <div className="brandTrack">
          {[
            "Audi.webp",
            "BMWNew.webp",
            "Mercedes.webp",
            "toyota.webp",
            "Honda.webp",
            "Hyundai.webp",
            "Volkswagen_New.webp",
            "LandRover.webp",
          ].map((logo, i) => (
            <img
              key={i}
              src={`/brands/${logo}`}
              alt="car brand"
            />
          ))}
          {/* duplicate for infinite scroll */}
          {[
            "Audi.webp",
            "BMWNew.webp",
            "Mercedes.webp",
            "toyota.webp",
            "Honda.webp",
            "Hyundai.webp",
            "LandRover.webp",
            "Volkswagen_New.webp",
          ].map((logo, i) => (
            <img
              key={`dup-${i}`}
              src={`/brands/${logo}`}
              alt="car brand"
            />
          ))}
        </div>
      </div>
    </section>
</>
  )
}
